import { ESTRATEGIA_RETRY_PADRAO, FalhaHttp, type ClienteHttp, type RespostaHttp } from '@next/infraestrutura/http'
import type { OpcaoUsuario } from '../catalogo-usuario.tipos'

const ENDPOINT = '/user'
const ehRegistro = (valor: unknown): valor is Record<string, unknown> => typeof valor === 'object' && valor !== null && !Array.isArray(valor)
const selecionarCampos = (valor: Record<string, unknown>, campos: readonly string[]): Record<string, unknown> => Object.fromEntries(campos.filter(campo => campo in valor).map(campo => [campo, valor[campo]]))
const projetar = (valor: Record<string, unknown>): OpcaoUsuario => {
  const resultado = selecionarCampos(valor, ['id', 'name', 'email', 'roleGroup', 'compemployee'])
  if (ehRegistro(valor.roleGroup)) resultado.roleGroup = selecionarCampos(valor.roleGroup, ['id', 'name', 'kind'])
  if (ehRegistro(valor.compemployee)) resultado.compemployee = selecionarCampos(valor.compemployee, ['id'])
  return resultado as OpcaoUsuario
}
const falhaInvalida = (resposta: RespostaHttp<unknown>): FalhaHttp => new FalhaHttp({
  tipo: 'resposta_invalida', servico: 'condominio', metodo: 'GET', endpoint: ENDPOINT,
  status: resposta.status, causa: resposta.data,
  ...(resposta.requestId ? { requestId: resposta.requestId } : {}),
})

const USUARIOS_POR_PAGINA = 1000
const CAMPOS = ['id', 'name', 'email', 'role_group', 'compemployee']
export class ListarOpcoesUsuarioRepositorioHttp {
  constructor(private readonly http: ClienteHttp) {}
  executar = async (sinal: AbortSignal): Promise<readonly OpcaoUsuario[]> => {
    const itens: OpcaoUsuario[] = []
    let pagina = 0
    let totalPaginas: number | null = null
    for (;;) {
      const resposta = await this.http.get<unknown>(ENDPOINT, {
        parametros: { fields: JSON.stringify(CAMPOS), order_by: 'name', deleted: false, page: pagina, per_page: USUARIOS_POR_PAGINA },
        signal: sinal, retry: ESTRATEGIA_RETRY_PADRAO,
      })
      const vazio = resposta.status === 204 || (ehRegistro(resposta.data) && 'no-data' in resposta.data)
      if (vazio) {
        if (totalPaginas !== null && pagina < totalPaginas) throw falhaInvalida(resposta)
        return itens
      }
      if (!ehRegistro(resposta.data) || !Array.isArray(resposta.data.success)) throw falhaInvalida(resposta)
      const quantidade = resposta.data.success.length
      const informado = resposta.data.totalPages
      const totalValido = typeof informado === 'number' && Number.isInteger(informado) && informado >= 0
      if (totalValido) {
        if ((totalPaginas !== null && informado !== totalPaginas) || (quantidade > 0 && informado <= pagina)) throw falhaInvalida(resposta)
        totalPaginas = informado
      }
      if (quantidade === 0 && totalPaginas !== null && pagina < totalPaginas) throw falhaInvalida(resposta)
      itens.push(...resposta.data.success.filter(ehRegistro).map(projetar))
      pagina++
      if (totalPaginas !== null ? pagina >= totalPaginas : quantidade < USUARIOS_POR_PAGINA) return itens
    }
  }
}
